module.exports = __webpack_public_path__ + "static/media/YOGI-SAD.edc27161.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/YOGI-SAD.png
// module id = 379
// module chunks = 0